export const LOGIN_TYPES = {
  EMAIL: 'email'
};
